import { gql } from '@apollo/client'

export const UPDATE_GROUP_ROLES = gql`
  mutation UpdateGroupRoles($groupId: ID!, $roleIds: [ID!]!) {
    updateGroupRoles(groupId: $groupId, roleIds: $roleIds)
  }
`
